import { Fragment } from 'react';

// Minimal, zero-dependency inline markdown renderer for changelog text items.
// Supports only the few inline patterns we author in-repo (trusted input):
//   [text](url)   -> <a>
//   **bold**      -> <strong>
//   `code`        -> <code>
// Everything else is rendered as plain text. No block-level markdown, no HTML injection.

// Order matters: code first (so its contents aren't re-parsed), then links, then bold.
const TOKEN = /(`[^`]+`)|(\[[^\]]+\]\([^)]+\))|(\*\*[^*]+\*\*)/g;

const renderInline = (text) => {
    if (typeof text !== 'string') {
        return text;
    }

    const nodes = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = TOKEN.exec(text)) !== null) {
        if (match.index > lastIndex) {
            nodes.push(text.slice(lastIndex, match.index));
        }

        const [token] = match;

        if (token.startsWith('`')) {
            nodes.push(<code key={key++}>{token.slice(1, -1)}</code>);
        } else if (token.startsWith('[')) {
            const linkMatch = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(token);
            nodes.push(
                <a key={key++} href={linkMatch[2]}>{linkMatch[1]}</a>
            );
        } else {
            nodes.push(<strong key={key++}>{token.slice(2, -2)}</strong>);
        }

        lastIndex = match.index + token.length;
    }

    if (lastIndex < text.length) {
        nodes.push(text.slice(lastIndex));
    }

    return <Fragment>{nodes}</Fragment>;
};

export default renderInline;
